import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面不存在 - 瓜圈速报",
    description: "这个地址没有对应的速报，返回瓜圈速报首页查看最新的突发爆料与第一手快讯。",
  });

  return (
    <>
      <SiteHeader />
      <main className="pt-28 md:pt-36 pb-20 px-4 md:px-10 min-h-[70vh] flex items-center justify-center">
        <div className="text-center max-w-lg">
          <span className="font-heading text-6xl md:text-8xl font-black text-foreground-200 select-none">404</span>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-black text-foreground-950">
            这条瓜好像被人删掉了
          </h1>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            你访问的地址
            <code className="mx-1 px-1.5 py-0.5 rounded bg-background-100 text-foreground-800 text-xs">
              {location.pathname}
            </code>
            没有对应的内容，可能是链接有误。回首页看最新速报吧。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </span>
              返回首页
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-bold whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors"
            >
              浏览全部速报
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}